"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schema = void 0;
const composit_1 = require("./composit");
const object_1 = require("./object");
const array_1 = require("./array");
const remoteSelect_1 = require("./remoteSelect");
const string_1 = require("./string");
const socialSecurityNumber_1 = require("./socialSecurityNumber");
const number_1 = require("./number");
const boolean_1 = require("./boolean");
const singleChoice_1 = require("./singleChoice");
const multiChoice_1 = require("./multiChoice");
const enum_1 = require("./enum");
const const_1 = require("./const");
const any_1 = require("./any");
const custom_1 = require("./custom");
const computed_1 = require("./computed");
const expression_1 = require("./expression");
const reference_1 = require("./reference");
const complexChoice_1 = require("./complexChoice");
const remoteMultiSelect_1 = require("./remoteMultiSelect");
exports.Schema = {
    form() {
        return exports.Schema.object().sealed().default({});
    },
    allOf(validators) {
        return new composit_1.AllOfValidator(validators);
    },
    anyOf(validators) {
        return new composit_1.AnyOfValidator(validators);
    },
    oneOf(validators) {
        return new composit_1.OneOfValidator(validators);
    },
    ifThenElse($if, $then, $else) {
        return new composit_1.ConditionalValidator($if, $then, $else);
    },
    ifThen($if, $then) {
        return new composit_1.ConditionalValidator($if, $then, exports.Schema.forbidden());
    },
    object() {
        return new object_1.ObjectValidator();
    },
    array() {
        return new array_1.ArrayValidator();
    },
    remoteSelect(path) {
        return new remoteSelect_1.RemoteSelectValidator({ path });
    },
    remoteMultiSelect(path) {
        return new remoteMultiSelect_1.RemoteMultiSelectValidator({ path });
    },
    string() {
        return new string_1.StringValidator();
    },
    date() {
        return exports.Schema.string().date();
    },
    time() {
        return exports.Schema.string().time();
    },
    dateTime() {
        return exports.Schema.string().dateTime();
    },
    email() {
        return exports.Schema.string().email();
    },
    phoneNumber() {
        return exports.Schema.string().phoneNumber();
    },
    stampNumber() {
        return exports.Schema.string().stampNumber();
    },
    socialSecurityNumber() {
        return new socialSecurityNumber_1.SocialSecurityNumberValidator();
    },
    number() {
        return new number_1.NumberValidator();
    },
    boolean() {
        return new boolean_1.BooleanValidator();
    },
    singleChoice(options) {
        return new singleChoice_1.SingleChoiceValidator({ options });
    },
    singleChoiceItem(value) {
        return new singleChoice_1.SingleChoiceItem({ value });
    },
    multiChoice(options) {
        return new multiChoice_1.MultiChoiceValidator({ options });
    },
    multiChoiceItem(value) {
        return new multiChoice_1.MultiChoiceItem({ value });
    },
    complexChoice(options) {
        return new complexChoice_1.ComplexChoiceValidator({ options });
    },
    complexChoiceItem(value, data) {
        return new complexChoice_1.ComplexChoiceItem({ value, data });
    },
    enum(values) {
        return new enum_1.EnumValidator({ values });
    },
    const(value) {
        return new const_1.ConstValidator({ value });
    },
    any() {
        return new any_1.AnyValidator();
    },
    forbidden() {
        return exports.Schema.any().forbidden();
    },
    custom(rule, details) {
        return new custom_1.CustomValidator({ rule, details });
    },
    computed(fn) {
        return computed_1.ComputedProvider.create(fn);
    },
    expression(template) {
        return expression_1.ExpressionProvider.create(template);
    },
    reference(path) {
        return reference_1.ReferenceProvider.create(path);
    }
};
